// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import className from 'classnames'
import styled, { type StyledComponent } from 'styled-components'
import type { Node } from 'react'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  &.radio-selector {
    padding-bottom: 10px;
  }

  .radio-selector__item {
    padding: 5px;
    display: inline-block;
    cursor: pointer;
  }

  .radio-selector__item_selected {
    background-color: rgba(73, 151, 220, 0.71);
    cursor: default;
  }
`

type Option = {|
  value: any,
  renderer: Node
|}

type Props = {|
  className?: string,
  radioOptions: Array<Option>,
  itemClass?: string,
  value: any,
  selectedItemClass?: string,
  onChange: (any) => void
|}

export default class RadioSelector extends Component<Props> {
  render() {
    const { onChange } = this.props

    return (
      <Wrapper className={this.props.className}>
        {_.map(this.props.radioOptions, (option) => (
          <div
            key={option.value}
            className={this.itemClass(option.value)}
            onClick={() => onChange && onChange(option.value)}
          >
            {option.renderer}
          </div>
        ))}
      </Wrapper>
    )
  }

  itemClass(optionValue: any) {
    const { itemClass, value, selectedItemClass } = this.props
    return className(itemClass, value === optionValue ? selectedItemClass : null)
  }

  static defaultProps = {
    className: 'radio-selector',
    itemClass: 'radio-selector__item',
    selectedItemClass: 'radio-selector__item_selected'
  }
}
